module.exports = __webpack_public_path__ + "static/img/img_award_header.625289f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_award_header.png
// module id = PBGk
// module chunks = 1